import inputData from './inputData/competitor-research-survey';
import { TemplateItem } from './types';
import { convertDraftParamsToLeadForm } from '../convertDraftParamsToLeadForm';

const previewInput = {
  workspaceId: 'preview-workspace',
  formId: 'preview-form',
  collectionId: 'preview-collection'
};

const template: TemplateItem = {
  id: 'competitor-research-survey',
  title: 'Competitor Research Survey',
  description: 'Identify gaps, spot opportunities, and stay ahead by learning how your audience views your competitors.',
  image: '/images/templates/competitor-research-survey.png',
  tags: ['get-feedback', 'product', 'marketing'],
  inputData: inputData,
  popular: true,
  formPreview: convertDraftParamsToLeadForm(inputData(),
    previewInput
  ),
}

export default template;

